module.exports = __webpack_public_path__ + "img/house_07.77081e34.jpg";